import React from 'react';
import HamburgerMenu from '../global/menu';
import { LOCATIONS, BRANDING } from '../config';
import '../global/styles.css';

// Logo is loaded dynamically based on config.js BRANDING.logoFilename
// Just place the logo file in src/assets/images/ with the name specified in config
const ClientLogo = require(`../assets/images/${BRANDING.logoFilename}`);

function DashboardHome({ userInfo, isAdmin = false, onLogout, onNavigate }) {

  // Get locations from config.js
  const locations = LOCATIONS;

  return (
    <div style={{ minHeight: '100vh', background: 'var(--background-color)', padding: '20px' }}>
      {/* Hamburger Menu */}
      <HamburgerMenu 
        isAdmin={isAdmin}
        onLogout={onLogout}
        onNavigate={onNavigate}
      />

      {/* Main Content */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', paddingTop: '20px' }}>
        
        {/* Header - Clean and Centered */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center',
          marginBottom: '40px' 
        }}>
          <img
            src={ClientLogo}
            alt={BRANDING.companyFullName}
            style={{ width: '120px', height: '120px', objectFit: 'contain' }}
          />
        </div>

        {/* Title */}
        <h1 style={{
          textAlign: 'center',
          color: 'var(--text-muted)',
          fontSize: '24px',
          fontWeight: '400',
          marginBottom: '50px',
          letterSpacing: '1px'
        }}>
          Log And Manage Your Inventory
        </h1>

        {/* Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '25px',
          maxWidth: '1000px',
          margin: '0 auto'
        }}>
          {locations.map(location => (
            <div
              key={location.id}
              style={{
                background: 'var(--card-background)',
                border: '1px solid var(--border-color)',
                borderRadius: '15px',
                padding: '30px 25px',
                textAlign: 'center',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-5px)';
                e.target.style.boxShadow = '0 6px 25px rgba(0, 0, 0, 0.15)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.1)';
              }}
            >
              <h3 style={{
                color: 'var(--text-color)',
                fontSize: '18px',
                fontWeight: '600',
                marginBottom: '20px',
                letterSpacing: '1px'
              }}>
                {location.name}
              </h3>
              <button 
                className="btn btn-primary btn-full"
                onClick={() => onNavigate(location.id)}
              >
                UPDATE INVENTORY
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default DashboardHome;